"use client";

import Image from "next/image";
import Link from "next/link";
import { frontendImage } from "@/lib/helpers";
import { useSection } from "@/app/_partials/_sections/_hooks/useSection";

export default function InfoPage({ page, pageSlug }) {
    const { content: breadcrumb, loading: breadcrumbLoading } =
        useSection("breadcrumb");

    return (
        <>
            {/* Breadcrumb Banner */}
            <section
                className="breadcrumb-banner-section bg-img"
                style={{
                    backgroundImage: `url(${frontendImage(
                        breadcrumb?.image,
                        "breadcrumb"
                    )})`,
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-banner text-center">
                                <h3 className="breadcrumb-banner__title mb-0">
                                    {page?.data?.page?.title || "Page Details"}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Page Details Section */}
            <section className="page-details-section section-bg py-60">
                <div className="container">
                    <div className="row gy-4">
                        {/* Main Content */}
                        <div className="col-lg-8 pe-xl-4">
                            <div className="page-details">
                                {page?.data?.page?.image && (
                                    <div className="page-details__thumb">
                                        <Image
                                            src={`${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/footer_pages/${page.data.page.image}`}
                                            alt={page.data.page.title}
                                            width={800}
                                            height={450}
                                            layout="responsive"
                                        />
                                    </div>
                                )}
                                <div className="page-details__content">
                                    <h5 className="page-details__title">
                                        {page?.data?.page?.title}
                                    </h5>

                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                page?.data?.page?.content || "",
                                        }}
                                    />

                                    {/* Facebook Comments */}
                                    <div
                                        className="fb-comments mt-4"
                                        data-href={`${process.env.NEXT_PUBLIC_SITE_URL}/${pageSlug}`}
                                        data-numposts="5"
                                        data-width="100%"
                                    ></div>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-lg-4">
                            <div className="page-details-sidebar-wrapper">
                                <h6 className="page-details-sidebar-wrapper__title">
                                    More Pages
                                </h6>

                                {page?.data?.related_pages?.data?.map(
                                    (link) => (
                                        <div
                                            className="page-details-sidebar"
                                            key={link.slug}
                                        >
                                            <Link
                                                href={`/${encodeURIComponent(
                                                    link.slug
                                                )}`}
                                                className="page-details-sidebar__thumb"
                                            >
                                                <Image
                                                    src={`${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/footer_pages/${link.image}`}
                                                    alt={link.title}
                                                    width={100}
                                                    height={70}
                                                />
                                            </Link>
                                            <div className="page-details-sidebar__content">
                                                <h6 className="page-details-sidebar__title">
                                                    <Link
                                                        href={`/${encodeURIComponent(
                                                            link.slug
                                                        )}`}
                                                    >
                                                        {link.title}
                                                    </Link>
                                                </h6>
                                                <span className="page-details-sidebar__desc">
                                                    {/* You can use a short description here if available */}
                                                    {link.short_description ||
                                                        "Click to view details"}
                                                </span>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
